const addRecentlyViewedItem = (type, id) => {
  const item = { type, id }
  if (window.AOL?.recentlyViewed) {
    window.AOL.recentlyViewed.add(item)
  } else {
    window.AOL = window.AOL || {}
    window.AOL._recentlyViewed = window.AOL._recentlyViewed || []
    window.AOL._recentlyViewed.push(item)
  }
}

module.exports = {
  addRecentlyViewedItem
}
